export const apiTokenId = 'goeland_api_token'
const http = new XMLHttpRequest()

const setDefaultHeader = () => {
  if (window.localStorage.getItem(apiTokenId)) {
    http.setRequestHeader('Authorization', `Bearer ${window.localStorage.getItem(apiTokenId)}`)
  }
  http.responseType = 'text'
  http.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
  if (import.meta.env.DEV) {
    http.setRequestHeader('accept', '*/*,text/html')
  }
}


const returnError = (status, response) => {
  response = JSON.parse(response)
  const resetCodes = [401, 409, 419]
  if (resetCodes.indexOf(response.code) >= 0) {
    window.localStorage.removeItem(apiTokenId)
    window.location.href = 'login'
  }
  console.error(`Error ${status}: ${response}`)
}

const prepareResponse = response => {
  response = JSON.parse(response)
  return response
}

// HTTP GET REQUEST
export const get = (url, callback, preapareResponse = true, responseType = 'text', headers = false) => {
  return new Promise((resolve, reject) => {
    http.open('GET', url, true)
    setDefaultHeader()
    if (headers) {
      headers.forEach(header => {
        http.setRequestHeader(header.type, header.val)
      })
    }
    if (responseType) {
      http.responseType = responseType;
    }

    http.onload = () => {
      if (http.status >= 200 && http.status <= 299) {
        try {
          let response = null
          switch (responseType) {
            case 'arraybuffer':
              response = http.response
              break
            default:
              response = http.responseText
          }
          resolve(callback(preapareResponse ? prepareResponse(response) : http.response))
        } catch (e) {
          console.error(e.message)
        }
      } else {
        reject(returnError(http.status, http.responseText))
      }
    }
    http.send()
  })
}

// HTTP POST REQUEST
export const post = (url, data, callback, headers, withContentType = false) => {
  http.open('POST', url, true)
  setDefaultHeader()
  if (withContentType) {
    http.setRequestHeader('content-type', 'application/json; charset=utf-8')
    data = JSON.stringify(data)
  }
  if (headers) {
    headers.forEach(header => {
      http.setRequestHeader(header.type, header.val)
    })
  }

  http.onload = () => {
    if (http.status >= 200 && http.status <= 299) {
      try {
        callback(prepareResponse(http.responseText))
      } catch (e) {
        console.error(e.message)
      }
    } else {
      returnError(http.status, http.responseText)
    }
  }
  http.send(data)
}

// HTTP POST REQUEST
export const upload = (url, file, callback, setProgressState) => {
  return new Promise((resolve, reject) => {
    http.open('POST', url, true)
    setDefaultHeader()
    http.upload.onprogress = e => {
      setProgressState(Math.ceil((e.loaded / e.total) * 100))
    }

    http.onload = () => {
      const response = JSON.parse(http.responseText)
      if (http.status >= 200 && http.status <= 299) {
        try {
          resolve(callback(response))
        } catch (e) {
          console.error(e.message)
        }
      } else {
        reject(returnError(http.status, response))
      }
    }
    const data = new FormData()
    data.append('file', file)
    http.send(data)
  })
}

// HTTP PUT REQUEST
export const put = (url, data, callback) => {
  http.open('PUT', url, true)
  setDefaultHeader()
  http.onload = () => {
    if (http.status >= 200 && http.status <= 299) {
      try {
        callback(prepareResponse(http.responseText))
      } catch (e) {
        console.error(e.message)
      }
    } else {
      returnError(http.status, http.responseText)
    }
  }
  http.send(JSON.stringify(data))
}

// HTTP DELETE REQUEST
export const deleteRequest = (url, data, callback) => {
  http.open('DELETE', url, true)
  setDefaultHeader()
  http.onload = () => {
    if (http.status >= 200 && http.status <= 299) {
      try {
        callback(prepareResponse(http.responseText))
      } catch (e) {
        console.error(e.message)
      }
    } else {
      returnError(http.status, http.responseText)
    }
  }
  http.send(JSON.stringify(data))
}
